/** Offen heißt: Status open und noch nicht abgelaufen. */
export function isOpenInvitation(
  row: { status: string; expires_at: string },
  nowMs: number,
): boolean {
  return row.status === "open" && new Date(row.expires_at).getTime() > nowMs;
}

export function countOpenInvitations(
  rows: readonly { status: string; expires_at: string }[],
  nowMs: number,
): number {
  return rows.filter((row) => isOpenInvitation(row, nowMs)).length;
}
